import React from 'react';
import { ContactForm } from './ContactForm/ContactForm';
import "../styles/ContactSection.scss"; 

const contactMeFormParagraph = "Got a development project you need help with? Whether you're starting from scratch, need a freelancer for a specific job, or you're just trying to get a stalled project across the finish line, I'm your guy. Fill out the form below with a quick rundown of what you're working with, and I'll reach out so we can talk through the details.";

const Contact = () => {

    return(
        <div id="contact" className="contact-section">
            <h3 className="contact-section-contact-title">CONTACT</h3>
            <div className="contact-section-contact-form">
                <h2 className="contact-section-form-title">Let's Build Something.</h2>
                <p className="contact-section-form-paragraph">{contactMeFormParagraph}</p>
                <ContactForm/>
            </div>
        </div>
    )

}

export default Contact; 